
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import moment from 'moment';

moment.locale('it');

@Component
export default class DatePickerDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Number)readonly operationId?: number | null;
  @Prop({ type: String, default: null }) readonly showBusyDatesType?: string | null;

  // La data da visualizzare (nel formato YYYY-MM-DD)
  @Prop({ type: String, default: null }) readonly date!: string | null;

  newValue: string | null = null
  newTextValue: string | null = null
  currentMonth: string | null = null
  busyMonthDates: number[] | null = null
  getBusyDatesTimeout: number | undefined

  dialog = false

  @Watch('value')
  onValueChange(val: boolean) {
    this.dialog = val;

    // Se il dialog è stato aperto...
    if (val === true) {
      // ... imposta la data iniziale da visualizzare
      this.newValue = this.date
        ? moment(this.date).toISOString(true).substring(0, 10)
        : null;

      // ... imposta il valore del campo di testo
      this.newTextValue = this.newValue
        ? moment(this.newValue, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : null;
    }
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  // Rileva la modifica del valore del campo di testo
  @Watch('newTextValue')
  onNewTextValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewTextValue() val =`, val); // eslint-disable-line no-console

    // Trasforma in un valore di tipo Date prima di restituirlo
    const newValue = val
      ? moment(val, 'DD/MM/YYYY', true).toDate()
      : null;
    console.log(`${this.constructor.name}: onNewTextValue() newValue =`, newValue); // eslint-disable-line no-console

    // Se è una data valida, la memorizza in this.newValue nel formato corretto
    if (newValue && moment(newValue).isValid()) {
      this.newValue = moment(newValue).format('YYYY-MM-DD');
    } else if (newValue === null) {
      // Se è null, la memorizza in this.newValue (data cancellata)
      this.newValue = null;
    }
  }

  // Rileva la modifica del valore del datepicker
  @Watch('newValue')
  onNewValue(val: string | null) {
    console.log(`${this.constructor.name}: onNewValue() val =`, val); // eslint-disable-line no-console

    // Trasforma in un valore di tipo Date prima di restituirlo
    const newValue = val
      ? moment(val, 'YYYY-MM-DD').toDate()
      : null;

    // Se è una data valida, la memorizza in this.newTextValue nel formato corretto
    if (newValue && moment(newValue).isValid()) {
      const newTextValue = moment(newValue).format('DD/MM/YYYY');
      if (this.newTextValue !== newTextValue) {
        this.newTextValue = newTextValue;
      }
    } else if (newValue === null) {
      // Se è null, la memorizza in this.newTextValue (data cancellata)
      if (this.newTextValue !== null) {
        this.newTextValue = null;
      }
    }
  }

  // Controlla se la data è valida
  isValid(val: string | null) {
    // Se è null, la data è valida
    if (val === null) {
      return true;
    }

    // Controlla se la data è valida
    const date = moment(val, 'DD/MM/YYYY', true).toDate();
    return moment(date).isValid();
  }

  // È stata selezionata una data
  async onSelect() {
    console.log(`${this.constructor.name}: onSelect() newValue =`, this.newValue); // eslint-disable-line no-console

    this.$emit('select', this.newValue);
  }

  async busyDatesForDate(id: number | null | undefined, date: string, type: string | null | undefined) {
    try {
      console.log(`${this.constructor.name}: busyDatesForDate() date=${date} type=${type}`); // eslint-disable-line no-console

      this.busyMonthDates = await this.$store.dispatch('checkBusyDatesForDate', { id, date, type }) ?? [];
    } catch (error) {
      console.log(`${this.constructor.name}: busyDatesForDate() error = `, error); // eslint-disable-line no-console
      this.busyMonthDates = [];
    }

    return Promise.resolve();
  }

  busyDates(date: string) {
    console.log(`${this.constructor.name}: busyDates`); // eslint-disable-line no-console

    // Se operationId è null, quindi non è richiamato dal TaskR, non fa nulla
    if ((this.operationId) && (this.showBusyDatesType !== null)) {
      const [year] = date.split('-');
      const [, month] = date.split('-');
      const [,, day] = date.split('-');

      // Evita di richiamare la funzione per ogni data del mese
      if (this.currentMonth !== `${year}${month}`) {
        // in caso di cambio mese, svuota l'array di date occupate...
        this.busyMonthDates = [];
        this.getBusyDatesTimeout = setTimeout(() => {
          console.log(`${this.constructor.name}: busyDates() timeout!`); // eslint-disable-line no-console

          // ... e recupera le nuove date
          this.busyDatesForDate(this.operationId, date, this.showBusyDatesType);
        }, 1000);

        this.currentMonth = `${year}${month}`;
      }
      let dateColor: string;

      // distinguo l'indicatore in base al tipo di evento
      switch (this.showBusyDatesType) {
        case 'connection':
          dateColor = 'orange';
          break;
        case 'commissioning':
          dateColor = 'blue';
          break;
        default:
          dateColor = 'orange';
          break;
      }

      if (this.busyMonthDates?.includes(parseInt(day, 10))) return [dateColor];
    }

    return false;
  }
}
